import { render, staticRenderFns } from "./SampleServerTable.vue?vue&type=template&id=7d8c6a89"
import script from "./SampleServerTable.vue?vue&type=script&lang=js"
export * from "./SampleServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports